module.exports = __webpack_public_path__ + "img/矩形 2943.b4a9c852.png";